import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "lesson-catalog"
};
var _hoisted_2 = {
  class: "catalog-list"
};
var _hoisted_3 = {
  class: "catalog-head"
};
var _hoisted_4 = ["onUpdate:modelValue", "onBlur"];
var _hoisted_5 = {
  class: "catalog-btn"
};
var _hoisted_6 = {
  class: "lesson-item"
};
var _hoisted_7 = {
  key: 0,
  class: "line-bottom"
};
var _hoisted_8 = {
  class: "lesson-box"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["data-id", "onUpdate:modelValue", "onBlur"];
var _hoisted_11 = {
  key: 0,
  class: "lesson-right-uploaded"
};
var _hoisted_12 = {
  key: 1,
  class: "lesson-right-uploading"
};
import draggable from 'vuedraggable';

/* 工具 */
import { ref, reactive, onMounted, nextTick, inject } from 'vue';
import { v4 } from 'uuid';
import { uploadObs } from 'hxhy-obs';
import { getEnv } from '@/util/env';
import { getStore } from '@/util/store';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';

/* api */
import { getLessonList, addLessonCatalog, editLessonTitle, deleteLesson, addLessonVideo, dragLessonVideo } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'LessonCatalog',
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var emit = __emit;
    var discussId = inject('discussId');
    var userInfo = getStore({
      name: 'userInfo'
    });
    var inputRef = ref();
    var lessonTitleRef = ref();
    var state = reactive({
      list: [],
      catalogId: null // 上传点击的目录id
    });

    /* 事件 */
    // 拖拽排序
    var dragSort = function dragSort(lessons) {
      var ids = lessons.map(function (e) {
        return e.id;
      });
      dragLessonVideo(discussId.value, ids).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('操作成功！');
        }
      });
    };

    // 获取课程目录列表
    var getCatalog = function getCatalog() {
      getLessonList(discussId.value, userInfo === null || userInfo === void 0 ? void 0 : userInfo.id).then(function (res) {
        if (res.data.code === 0) {
          var list = res.data.data || [];
          list.forEach(function (e) {
            !e.children && (e.children = []);
            e.children.forEach(function (c) {
              c.editing = false;
            });
          });
          state.list = list;
        }
      });
    };

    // 删除目录/视频
    var handleDelete = function handleDelete(id, header, body, cb) {
      var dialog = DialogPlugin({
        header: header,
        body: body,
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          deleteLesson(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              cb && cb();
              MessagePlugin.success('删除成功！');
              emit('change');
              dialog.destroy();
            }
          });
        }
      });
    };

    // 点击目录条标题的span
    var lessonTitleSpan = function lessonTitleSpan(lesson) {
      lesson.editing = true;
      var _loop = function _loop() {
        var _ipt$dataset;
        var ipt = lessonTitleRef.value[i];
        if (((_ipt$dataset = ipt.dataset) === null || _ipt$dataset === void 0 ? void 0 : _ipt$dataset.id) === lesson.id) {
          nextTick(function () {
            ipt.focus();
          });
        }
      };
      for (var i = 0; i < lessonTitleRef.value.length; i++) {
        _loop();
      }
    };

    // 目录标题失去焦点
    var lessonTitleBlur = function lessonTitleBlur(lesson) {
      lesson.editing = false;
      handleEditTitle(lesson.id, lesson.title);
    };

    // 更改目录标题
    var handleEditTitle = function handleEditTitle(id, title) {
      if (!title.length) return;
      if (title.length > 15) {
        MessagePlugin.warning('资料名称最多15个字！');
        return;
      }
      var data = {
        id: id,
        title: title
      };
      editLessonTitle(discussId.value, data).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('修改成功！');
        }
      });
    };

    // 添加目录
    var addCatalog = function addCatalog() {
      var data = {
        discussId: discussId.value,
        title: ''
      };
      addLessonCatalog(data).then(function (res) {
        if (res.data.code === 0) {
          var item = {
            id: res.data.data,
            title: '',
            children: []
          };
          state.list.push(item);
          MessagePlugin.success('添加成功！');
        }
      });
    };

    // 删除目录
    var delCatalog = function delCatalog(id) {
      handleDelete(id, '删除课程目录', '是否删除该目录', function () {
        var index = state.list.findIndex(function (e) {
          return e.id === id;
        });
        index !== -1 && state.list.splice(index, 1);
      });
    };

    // 删除课程
    var delLesson = function delLesson(catalogId, lessonId) {
      handleDelete(lessonId, '删除课程', '是否删除该课程', function () {
        var catalogIndex = state.list.findIndex(function (e) {
          return e.id === catalogId;
        });
        if (catalogIndex !== -1) {
          var lessonIndex = state.list[catalogIndex].children.findIndex(function (e) {
            return e.id === lessonId;
          });
          lessonIndex !== -1 && state.list[catalogIndex].children.splice(lessonIndex, 1);
        }
      });
    };

    // 点击上传
    var uploadClick = function uploadClick(id) {
      state.catalogId = id;
      inputRef.value.click();
    };

    // 进度回调函数
    var setProgress = function setProgress(transferredAmount, totalAmount, totalSeconds, lessonItem) {
      var progress = parseInt(transferredAmount * 100.0 / totalAmount);
      lessonItem.uploadProgress = "".concat(progress, "%");
    };

    // 上传获取url
    var getUrl = function getUrl(lessonItem) {
      return new Promise(function (resolve) {
        var obsData = {
          bucketName: "hxhy-activity-".concat(getEnv()),
          file: lessonItem.file,
          fileType: 3,
          userId: userInfo.id,
          userName: userInfo.name,
          institutionId: userInfo.institutionId,
          institutionName: userInfo.institutionName,
          appCode: 'activity',
          appName: '活动',
          pageName: 'researchTrain',
          btnName: '研训在线课程课程上传',
          progressCallback: function progressCallback() {
            return setProgress.apply(void 0, Array.prototype.slice.call(arguments).concat([lessonItem]));
          }
        };
        uploadObs(obsData).then(function (url) {
          resolve(url);
        });
      });
    };

    // 获取视频时长
    var getDuration = function getDuration(file) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var audioElement = new Audio(url);
        audioElement.addEventListener('loadedmetadata', function () {
          var duration = audioElement.duration;
          resolve(duration);
        });
      });
    };

    // 上传到课程目录内
    var uploadToLesson = function uploadToLesson(lesson) {
      return new Promise(function (resolve) {
        var data = {
          discussId: discussId.value,
          parentId: state.catalogId,
          video: {
            title: lesson.title,
            url: lesson.url,
            totalDuration: lesson.totalDuration
          }
        };
        addLessonVideo(data).then(function (res) {
          if (res.data.code === 0) {
            lesson.id = res.data.data;
            emit('change');
            resolve();
          }
        });
      });
    };

    // 上传回调
    var uploadChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var _e$target;
        var files, index, lessons, i, file, suffxIndex, fileName, pushItem, _i, lesson, url, duration;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              files = (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files) || [];
              index = state.list.findIndex(function (itm) {
                return itm.id === state.catalogId;
              });
              lessons = state.list[index].children;
              i = 0;
            case 1:
              if (!(i < files.length)) {
                _context.n = 4;
                break;
              }
              file = files[i];
              suffxIndex = file.name.indexOf('.');
              fileName = file.name.substring(0, suffxIndex);
              if (!(fileName.length > 15)) {
                _context.n = 2;
                break;
              }
              MessagePlugin.warning('资料名称最多15个字！');
              return _context.a(3, 3);
            case 2:
              pushItem = {
                id: v4(),
                title: fileName,
                uploading: true,
                uploadProgress: '0%',
                file: file
              };
              index !== -1 && lessons.push(pushItem);
            case 3:
              i++;
              _context.n = 1;
              break;
            case 4:
              if (!(index !== -1)) {
                _context.n = 13;
                break;
              }
              _i = 0;
            case 5:
              if (!(_i < lessons.length)) {
                _context.n = 13;
                break;
              }
              lesson = lessons[_i];
              if (!(lesson.uploading && lesson.file)) {
                _context.n = 12;
                break;
              }
              if (!lesson.cancel) {
                _context.n = 6;
                break;
              }
              lesson.uploading = false;
              return _context.a(3, 12);
            case 6:
              _context.n = 7;
              return getUrl(lesson);
            case 7:
              url = _context.v;
              lesson.url = url;
              if (!lesson.cancel) {
                _context.n = 8;
                break;
              }
              lesson.uploading = false;
              return _context.a(3, 12);
            case 8:
              _context.n = 9;
              return getDuration(lesson.file);
            case 9:
              duration = _context.v;
              lesson.totalDuration = duration;
              if (!lesson.cancel) {
                _context.n = 10;
                break;
              }
              lesson.uploading = false;
              return _context.a(3, 12);
            case 10:
              _context.n = 11;
              return uploadToLesson(lesson);
            case 11:
              lesson.uploading = false;
            case 12:
              _i++;
              _context.n = 5;
              break;
            case 13:
              document.getElementById('file').value = ''; // 清空上传数据
            case 14:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function uploadChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 取消上传课程
    var cancelUpload = function cancelUpload(catalogId, lesson) {
      var index = state.list.findIndex(function (itm) {
        return itm.id === catalogId;
      });
      var lessons = state.list[index].children;
      state.list[index].children = lessons.filter(function (itm) {
        return itm.id !== lesson.id;
      });
      lesson.cancel = true;
    };

    /* 钩子 */
    onMounted(function () {
      getCatalog();
    });
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
        id: "file",
        ref_key: "inputRef",
        ref: inputRef,
        accept: "video/*",
        type: "file",
        multiple: "",
        onChange: uploadChange
      }, null, 544), [[_vShow, false]]), _createElementVNode("div", {
        class: "head"
      }, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "must"
      }, [_createElementVNode("i", null, "*"), _createTextVNode("课程目录 ")], -1)), _createElementVNode("span", {
        class: "btn",
        onClick: addCatalog
      }, "添加章节")]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list, function (catalog) {
        return _openBlock(), _createElementBlock("div", {
          key: catalog.id,
          class: "catalog-item"
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return catalog.title = $event;
          },
          type: "text",
          placeholder: "请输入章节名称",
          maxlength: "15",
          onBlur: function onBlur($event) {
            return handleEditTitle(catalog.id, catalog.title);
          }
        }, null, 40, _hoisted_4), [[_vModelText, catalog.title]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_t_icon, {
          name: "upload",
          size: "16px",
          onClick: function onClick($event) {
            return uploadClick(catalog.id);
          }
        }, null, 8, ["onClick"]), _createVNode(_component_t_icon, {
          name: "delete",
          size: "16px",
          onClick: function onClick($event) {
            return delCatalog(catalog.id);
          }
        }, null, 8, ["onClick"])])]), _createVNode(_unref(draggable), {
          class: "lesson-list",
          list: catalog.children,
          "item-key": "id",
          "ghost-class": "ghost",
          "chosen-class": "chosenClass",
          animation: "300",
          onSort: function onSort($event) {
            return dragSort(catalog.children);
          }
        }, {
          item: _withCtx(function (_ref3) {
            var lesson = _ref3.element,
              index = _ref3.index;
            return [_createElementVNode("div", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "line-top"
            }, null, -1)), index !== catalog.children.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("span", {
              class: "lesson-title-span",
              onClick: function onClick($event) {
                return lessonTitleSpan(lesson);
              }
            }, _toDisplayString(lesson.title), 9, _hoisted_9), [[_vShow, !lesson.editing]]), _withDirectives(_createElementVNode("input", {
              ref_for: true,
              ref_key: "lessonTitleRef",
              ref: lessonTitleRef,
              "data-id": lesson.id,
              class: "lesson-title",
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return lesson.title = $event;
              },
              type: "text",
              onBlur: function onBlur($event) {
                return lessonTitleBlur(lesson);
              }
            }, null, 40, _hoisted_10), [[_vShow, lesson.editing], [_vModelText, lesson.title]]), !lesson.uploading ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_t_icon, {
              name: "delete",
              size: "16px",
              onClick: function onClick($event) {
                return delLesson(catalog.id, lesson.id);
              }
            }, null, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "上传中", -1)), _createElementVNode("span", null, _toDisplayString(lesson.uploadProgress), 1), _createVNode(_component_t_icon, {
              name: "close",
              size: "16px",
              onClick: function onClick($event) {
                return cancelUpload(catalog.id, lesson);
              }
            }, null, 8, ["onClick"])]))])])];
          }),
          _: 2
        }, 1032, ["list", "onSort"])]);
      }), 128))])]);
    };
  }
};